import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  saveInvoiceBtnWrapper: {
    marginRight: theme.spacing(2.5)
  },
  menuPopper: {
    minWidth: 230
  }
}))
